import React from 'react';

import { LoginCard } from '@/components/organisms/Auth';
import { LoginLayout } from '@/components/templates/LoginLayout';
import { CmBox, CmHeading, CmText } from '@/components/uiParts';
import { routes } from '@/router';

import { ResetPasswordForm } from './components/ResetPasswordForm';
import { usePasswordReset } from './hooks/usePasswordReset';

const ResetPasswordPage = (): JSX.Element => {
  const passwordReset = usePasswordReset();

  return (
    <LoginLayout>
      <LoginCard>
        <CmHeading fontSize="2xl" mb={5} as="h1">
          {routes.ResetPassword.title}
        </CmHeading>
        <CmBox mb={8}>
          <CmText>
            パスワードの再設定を行います。新しいパスワードを入力してください。
          </CmText>
        </CmBox>
        <ResetPasswordForm onSubmit={passwordReset} />
      </LoginCard>
    </LoginLayout>
  );
};

export default ResetPasswordPage;
